import { getProductIdFromProductCode } from '@noths/polaris-client-utils';
import { Product } from '@noths/polaris-dev-ts-types';

export const transformProductsToGAReturnedProductsArray = (products: Product[]) => {
  return products.map(({ code }) => ({
    product: {
      id: String(getProductIdFromProductCode(code)),
    },
  }));
};
